import get from 'lodash/get';
import { createSelector } from 'reselect';
import { RootState } from 'store/types';

import { GlobalSearchItem } from 'store/global/types';
import { DetailDownloadState, PaymentDownloadState } from './reducers';

export const detailDownloadSelector = (state: RootState) => state.billing.detailsDownload;
export const detailDownloadFetchingSelector = createSelector(
  detailDownloadSelector,
  (detailsDownload: DetailDownloadState) => detailsDownload.isFetching
);
export const detailDownloadDataSelector = createSelector(
  detailDownloadSelector,
  (detailsDownload: DetailDownloadState) => detailsDownload.data
);

export const paymentDownloadSelector = (state: RootState) => state.billing.paymentsDownload;

export const paymentDownloadFetchingSelector = createSelector(
  paymentDownloadSelector,
  (paymentsDownload: PaymentDownloadState) => paymentsDownload.isFetching
);
export const paymentDownloadDataSelector = createSelector(
  paymentDownloadSelector,
  (paymentsDownload: PaymentDownloadState) => paymentsDownload.data
);
export const getPaymentDetailDataSelector = (state: RootState) =>
  get(state, 'billing.paymentDetail.data');

export const getPaymentDetailFetchingSelector = (state: RootState) =>
  get(state, 'billing.paymentDetail.isFetching');

export const getPaymentDetailErrorSelector = (state: RootState) =>
  get(state, 'billing.paymentDetail.error');

export const getEncounterDetailDataSelector = (state: RootState) =>
  get(state, 'billing.encounterDetail.data');

export const getEncounterDetailFetchingSelector = (state: RootState) =>
  get(state, 'billing.encounterDetail.isFetching');

export const getEncounterDetailErrorSelector = (state: RootState) =>
  get(state, 'billing.encounterDetail.error');

export const getPaymentsListDataSelector = (state: RootState) =>
  state.billing.paymentsList?.data || [];
export const getPaymentsListFetchingSelector = (state: RootState) =>
  state.billing.paymentsList?.isFetching;
export const getPaymentsListErrorSelector = (state: RootState) => state.billing.paymentsList?.error;

export const getPaymentsSummarySelector = (state: RootState) => state.billing.paymentsSummary;
export const getBillingSummarySelector = (state: RootState) => state.billing.billingSummary;
export const getBillsSelector = (state: RootState) => state.billing.bills;
export const getCollectionsDetailsSelector = (state: RootState) => state.billing.collectionsDetails;
export const getHsaSummarySelector = (state: RootState) => state.billing.hsaSummary;
export const getPaymentPlanSummarySelector = (state: RootState) => state.billing.paymentPlanSummary;
export const getPaymentsListSelector = (state: RootState) => state.billing.paymentsList;
export const getFinancialAssistanceSummarySelector = (state: RootState) =>
  state.billing.financialAssistanceSummary;
export const getFinancialAssistanceApplicationsSelector = (state: RootState) =>
  state.billing.financialAssistanceApplications;
export const getFinancialAssistanceApplicationSelector = (state: RootState) =>
  state.billing.financialAssistanceApplication;
export const getBillingVisitSummarySelector = (state: RootState) =>
  state.billing.billingVisitSummary;
export const getFinancialAssistanceHasPendingSelector = (state: RootState) =>
  state.billing.financialAssistanceSummary.data?.hasPendingApplications;

export const getBillingRequestStateSelector = (
  type:
    | 'paymentsSummary'
    | 'billingSummary'
    | 'bills'
    | 'hsaSummary'
    | 'paymentsList'
    | 'paymentPlanSummary'
    | 'financialAssistanceSummary'
    | 'financialAssistanceApplications'
    | 'financialAssistanceApplication'
    | 'billingVisitSummary'
) => (state: RootState) => state.billing[type].requestState;

export const searchFormattedBilling: GlobalSearchItem[] = [
  {
    title: 'Billing Dashboard',
    keywords: ['pay', 'finance', 'financial'],
    navWebPath: `/u/billing`,
    icon: 'PaymentPlan',
    weight: 1
  },
  {
    title: 'View and Pay Bills',
    keywords: ['pay', 'finance', 'financial', 'billing'],
    category: 'Billing',
    navWebPath: `/u/billing/bills`,
    icon: 'Money',
    weight: 0.9
  },
  {
    title: 'Payment History',
    keywords: ['pay', 'payment', 'billing'],
    category: 'Billing',
    navWebPath: `/u/billing/payment-history`,
    icon: 'PaymentHistory',
    weight: 0.8
  },
  {
    title: 'Apply for Financial Assistance',
    keywords: ['help'],
    category: 'Billing',
    navWebPath: `/u/fa-app/start`,
    icon: 'Bill',
    weight: 0.9
  },
  {
    title: 'Financial Assistance Application Status',
    keywords: ['help', 'apply'],
    category: 'Billing',
    navWebPath: `/u/fa-app/status`,
    icon: 'Bill',
    weight: 0.8
  },
  {
    title: 'Financial Assistance Eligibility Information',
    keywords: ['help'],
    category: 'Billing',
    navWebPath: `/u/fa-app/eligibility`,
    icon: 'Bill',
    weight: 0.7
  },
  {
    title: 'Financial Assistance FAQ',
    keywords: ['help', 'FAQ'],
    category: 'Billing',
    navWebPath: `/u/fa-app/faq`,
    icon: 'Bill',
    weight: 0.6
  }
];
